import { Outlet, useParams } from "@tanstack/react-router";
import { SUPPORT_TOOLS } from "./constants";
import { useToolHealthCheck } from "./hooks";
import { SupportToolsList } from "./SupportToolsList";
import type { SupportToolsListProps } from "./types";

export const SupportToolsLayout = ({ showHeader = true, isOrgContext = false }: SupportToolsListProps) => {
  const { tool } = useParams({ strict: false });
  const isMainPage = !tool;

  // Health check state for main page
  const healthCheckHook = useToolHealthCheck(SUPPORT_TOOLS);

  const content = isMainPage ? (
    <SupportToolsList healthCheckHook={healthCheckHook} showHeader={showHeader} />
  ) : (
    <Outlet />
  );

  // For org context, return content directly (OrgPageLayout provides wrapper)
  if (isOrgContext) {
    return content;
  }

  // For global context, provide wrapper
  return (
    <div className="h-full min-h-screen">
      <div className="p-6">{content}</div>
    </div>
  );
};
